import { useTranslation } from "react-i18next";

import { IconFileShield02 } from "@pentabd/icons";

import { EmployeeHeader } from "@components";

import { ROUTES } from "@constants/routes";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

const {
  HRM: { PROVIDENT_FUND },
} = ROUTES;
interface InstallmentDetailsPageHeaderProps {
  employee: EmployeeCommonInfoType;
}

export const InstallmentDetailsPageHeader = ({
  employee,
}: InstallmentDetailsPageHeaderProps) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconFileShield02 size="20" />,
    },
    {
      label: t("INSTALLMENT_DETAILS.BREADCRUMBS.FIRST_STEP"),
      link: PROVIDENT_FUND,
    },
    {
      label: t("INSTALLMENT_DETAILS.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  return <EmployeeHeader breadcrumbs={breadcrumbs} employee={employee} />;
};
